import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import StyledChip from 'common/theme/chips/StyledChip';

function AvailableSessionsChip({ availableSessions, personalizedSessions = 0 }) {
  const { t } = useTranslation(['sessions']);

  const getSessionChipColor = (count) => {
    if (count === 0) return 'error';
    if (count < 5) return 'secondary';
    return 'primary';
  };

  const count = personalizedSessions > 0 ? personalizedSessions : availableSessions;
  const label = `${count} ${t('availableSessions', { ns: 'sessions' })}`;

  return (
    <StyledChip
      label={label}
      color={getSessionChipColor(count)}
      sx={{ maxWidth: 'none', flexShrink: 0, '& .MuiChip-label': { whiteSpace: 'nowrap' } }}
    />
  );
}

AvailableSessionsChip.propTypes = {
  availableSessions: PropTypes.number.isRequired,
  personalizedSessions: PropTypes.number
};

export default AvailableSessionsChip;
